export const MAIN_COLUMN_WIDTH = "50%";
export const MAIN_COLUMN_SIZE = 50;
export const MAIN_OWNERS_COLUMN_SIZE = 75;

export const USER_NAME_COLUMN_WIDTH = "35%";

export const ROLES_AND_OWNERS_INFO_COLUMN_SIZE = 15;

export const SELECTION_COLUMN_ID = "selection";
